export default {
  GET_ACTIVITY_AUTUMN_PAGE: '/MidAutumn/TaskInfo',
};
